import $ from "jquery";
import { endsWith } from "./typescript/Vgr.Util";
import {
    handleKeyDown,
    getScopeUrlParam,
    getHsaIdUrlParam,
    addSearchQueries,
    addWww,
    addDokument,
    addVerksamhet,
    addPerson,
    addCloseResultContainerListener,
} from "./AutocompleteUtil";

//*********Extended Autocomplete*********//
export default function initializeAutocomplete() {
    var useAutocomplete = $(document.body).data("useautocomplete") == true;

    if (!useAutocomplete) return;

    var urlRightPart = location.pathname;

    // Kolla om enkel urler finns med i urlen , ta bort de annars kan den inte hitta post metoden i kontollen och i sin tur skickar den ett exeption
    if (urlRightPart !== null || urlRightPart !== undefined) {
        if (
            endsWith(urlRightPart, "nu") ||
            endsWith(urlRightPart, "su") ||
            endsWith(urlRightPart, "sas") ||
            endsWith(urlRightPart, "skas") ||
            endsWith(urlRightPart, "narhalsan")
        ) {
            urlRightPart = urlRightPart.substr(0, urlRightPart.lastIndexOf("/"));
        }
    }

    // Append a slash if it's missing
    if (!endsWith(urlRightPart, "/")) {
        urlRightPart += "/";
    }

    var urlPath = "/hittasearch/hittaquerycompletion";
    var arrowLeft = 37;
    var arrowUp = 38;
    var arrowRight = 39;
    var arrowDown = 40;
    var tab = 9;
    var escape = 27;
    var searchField = $("#search");
    var resultContainer = $("#autocomplete-result");
    var searchButton = $("#search-button");
    var topDiv = $("#result-topdiv");
    var bottomDiv = $("#result-bottomdiv");
    var isInternal = document.querySelector("input[name=isInternal]");
    var searchForm = $(".search-form");
    resultContainer.append(topDiv);
    resultContainer.append(bottomDiv);
    addCloseResultContainerListener(searchField, searchButton, resultContainer);
    searchField.on("keydown", function (event) {
        if (
            event.keyCode === arrowDown ||
            event.keyCode === arrowUp ||
            event.keyCode === arrowRight ||
            event.keyCode === arrowLeft ||
            event.keyCode === tab ||
            event.keyCode === escape
        ) {
            urlPath = "";
            var autoCompleteLinks = document.querySelectorAll(".autocomplete__link");

            autoCompleteLinks.forEach(function (el) {
                el.addEventListener("keydown", function (event) {
                    if (
                        event.keyCode === arrowDown ||
                        event.keyCode === arrowUp ||
                        event.keyCode === arrowRight ||
                        event.keyCode === arrowLeft ||
                        event.keyCode === tab ||
                        event.keyCode === escape
                    ) {
                        event.preventDefault();
                        handleKeyDown(event);
                    }
                });
            });

            handleKeyDown(event);
        } else {
            urlPath = "/api/hittasearch/querycompletion";
            var scope = getScopeUrlParam();
            var hsaid = getHsaIdUrlParam();

            searchField.autocomplete({
                minLength: 1,
                delay: 0,
                source: function (request, response) {
                    $.ajax({
                        dataType: "json",
                        url: urlPath,
                        type: "Get",
                        data: {
                            url: urlRightPart,
                            q: request.term == undefined || request.term == null || request.term == ' ' ? "*" : request.term,
                            scope: scope,
                            hsaid: hsaid,
                            category: "www"
                        },
                        success: function (data) {
                            if (data === "") return;
                            // var requestFrom = data.substring(0, 1); //i/e, internal or external
                            var jsObject = JSON.parse(data);
                            if (jsObject.suggestions.length === 0) {
                                resultContainer.addClass("hidden");
                                return;
                            }
                            topDiv.html("");
                            bottomDiv.html("");

                            resultContainer.removeClass("hidden");
                            resultContainer.removeClass("visually-hidden");
                            var searchQueries = $(jsObject.suggestions).filter(function (
                                i,
                                n
                            ) {
                                return n.category === "search_query";
                            });
                            var www = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "www";
                            });
                            var dokument = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "dokument";
                            });
                            var verksamhet = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "verksamhet";
                            });
                            var person = $(jsObject.suggestions).filter(function (i, n) {
                                return n.category === "person";
                            });

                            if(searchQueries.length > 0) {
                                addSearchQueries(searchQueries, topDiv);
                            }
                            if(www.length > 0) {
                                addWww(www, topDiv);
                            }
                            if(dokument.length > 0) {
                                addDokument(dokument, bottomDiv);
                            }
                            if (isInternal?.value == "True") {
                                if(person.length > 0) {
                                    addPerson(person, bottomDiv, false);
                                }
                            }
                            else {
                                if(verksamhet.length > 0) {
                                    addVerksamhet(verksamhet, bottomDiv, false);
                                }
                            }

                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.error(errorThrown)
                        },
                    });
                },
            });
        }
    });
}
